<template>
  <div class="rounded-lg py-1 flex-grow-1"
    :data-aos="animation"
    data-aos-easing="ease"
    data-aos-duration="500"
    data-aos-once="true">
    <Topico :titulo="topico" v-if="topico" />
    <Subtopico :titulo="subTopico" v-if="subTopico" />
    <slot></slot>
  </div>
</template>

<script>
import Topico from "./Topico.vue";
import Subtopico from "./Subtopico.vue";

export default {
  props: {
    topico: {
      type: String,
      required: false,
    },
    subTopico: {
      type: String,
      required: false,
    },
    animation: {
      type: String,
      required: false,
      default: "fade-right",
    },
  },

  components: {
    Topico,
    Subtopico,
  },
};
</script>

<style></style>
